import { isNumber } from 'lodash'
import { createVirtualGrid } from './virtual-grid'
import { coreTableProps } from '../props'
import { createHeader } from './header'
import { createEmpty } from './empty'
import { createFooter } from './footer'
import { MAIN_TABLE, LEFT_TABLE, UPDATE_STORE_PARAMS, FIXD_SHOW_INDEX } from '../config'

const VirtualGrid = createVirtualGrid()
const Header = createHeader()
const Empty = createEmpty()
const Footer = createFooter()

export function createdCoreTable() {
  return {
    name: 'CoreTable',
    props: coreTableProps,
    computed: {
      isMainTable () {
        return this.$props.type === MAIN_TABLE
      },
      columnsVisible() {
        const columns = this.columns
        return this.isMainTable ? this.store.viewportRenderColumns.filter(i => !(i.children && i.children.length)) : columns.filter(i => !(i.children && i.children.length))
      },
      headerColumns () {
        const columns = this.columns
        return this.isMainTable ? this.store.viewportRenderColumns : columns
      }
    },
    methods: {
      scrollTo(params) {
        if (this.$refs.virtualGrid) {
          this.$refs.virtualGrid.doScroll(params)
        }
        if (this.$refs.headerRef) {
          this.$refs.headerRef.scrollToLeft(params.scrollLeft)
        }
        this.setFooterGridLeft(params.scrollLeft)
      },
      scrollToTop(params) {
        if (this.$refs.virtualGrid) {
          this.$refs.virtualGrid.doScroll(params)
        }
      },
      scrollToLeft(scrollLeft) {
        if (this.$refs.virtualGrid) {
          this.$refs.virtualGrid.doScroll({ scrollLeft })
        }
        this.setFooterGridLeft(scrollLeft)
      },
      scrollToRow(rowNumber) {
        if (rowNumber && typeof rowNumber === 'number') {
          const { rowHeight } = this.$props
          const scrollTop = parseInt(rowNumber * rowHeight)
          this.scrollToTop({
            scrollTop
          })
        }
      },
      setFooterGridLeft(scrollLeft) {
        if (this.$refs.footerGrid) {
          this.$refs.footerGrid.scrollToLeft(scrollLeft)
        }
      },
      forceUpdate() {
        this.$forceUpdate()
        this.$forceUpdate()
      },
      handleEvent(event, attrs) {
        const { table } = this.$props.store
        const { eventType, execRow = true, ...restAttrs } = attrs || {}
        table.$emit(`cell-${eventType}`, restAttrs, event)
        execRow && table.$emit(`row-${eventType}`, restAttrs, event)
        this.saveTableActionStatus(event, eventType, restAttrs)
      },
      saveTableActionStatus(event, eventType, { rowData, rowIndex, renderDataIndex, column } = {}) {
        // 存在renderDataIndex才高亮，即是表体的数据才会设置 renderDataIndex 的值。页脚和固定行都不存在renderDataIndex，使用的是自己的数据
        if (eventType === 'click' && isNumber(renderDataIndex) && renderDataIndex > -1) {
          this.store.commit(UPDATE_STORE_PARAMS, {
            selectdInfo: {
              currentRow: rowData,
              currentRowIndex: rowIndex,
              renderDataIndex
            }
          })
          if (column.key === '_selection') {
            this.store.rowSelectedChangedByClick(rowData, rowIndex)
          }
        }
      },
      handleHeaderEvent(event, attrs) {
        const { table } = this.$props.store
        const { eventType, ...restAttrs } = attrs
        table.$emit(`header-${eventType}`, {...restAttrs, event})
      },
      getIndexValue(rowInfo) {
        const { $props, store } = this
        const table = store.table
        let index = $props.showIndexType === FIXD_SHOW_INDEX ? rowInfo.rowIndex + 1 : rowInfo.rowData.$index || rowInfo.rowData._index
        const indexMethod = table && table.$props.indexMethod
        if (indexMethod && typeof indexMethod === 'function') {
          index = indexMethod(index)
        }
        if (index > store.states.tableDataLength) {
          store._curMaxIndexVal = index
        }
        return index
      }
    },
    render() {
      const { $props, $slots } = this
      const [slots] = $slots.default || []
      const { _tableData } = this.store
      const fixedRows = ($props.fixedRowsTop ? _tableData.slice(0, $props.fixedRowsTop) : $props.fixedRowsData) || []
      const footerRows = $props.footerRows || []
      const hasFooter = !!footerRows.length
      const isEmpty = _tableData.length === 0
      const showMainTableEmpty = this.isMainTable
      const commonRowParams = {
        columns: this.columnsVisible,
        handleEvent: this.handleEvent
      }
      const renderTableBody = () => {
        const createEmptyNode = () => {
          if (isEmpty && this.columnsVisible.length) {
            // 只有main-table才显示空组件
            if (!showMainTableEmpty) {
              if (hasFooter && $props.type === LEFT_TABLE) {
                return <div style="visibility: hidden;"> { slots.empty || <Empty width={this.width} height={$props.height}></Empty>} </div>
              }
              return null
            }
            return slots.empty || <Empty width={this.width} height={$props.height} emptyText={$props.emptyText}></Empty>
          } else {
            // 没有表头的情况。
            if (!this.columnsVisible.length) {
              // console.error('【table2-coreTable】：表格列配置为空，请检查或重新获取')
              return null
            }
          }
        }
        const virtualGridAttrs = {
          props: {
            store: $props.store,
            width: this.width,
            height: $props.height,
            enableDynamicHeight: $props.enableDynamicHeight,
            rowHeight: $props.rowHeight,
            rowTotalHeight: $props.rowTotalHeight,
            tableWidth: $props.tableWidth,
            columnTotalWidth: $props.bodyWidth,
            columns: this.columnsVisible,
            showIndexType: $props.showIndexType,
            type: $props.type,
            hScrollbarSize: $props.hScrollbarSize,
            vScrollbarSize: $props.vScrollbarSize,
            scrollbarStyle: $props.scrollbarStyle,
            highlightCurrentRow: $props.highlightCurrentRow,
            scrollbarAlwaysOn: $props.scrollbarAlwaysOn
          },
          on: {
            scroll: $props.scroll
          },
          ref: 'virtualGrid'
        }
        return <VirtualGrid {...virtualGridAttrs}>
          {{
            default: (params) => {
              return slots.row({
                ...params,
                ...commonRowParams,
                _index: this.getIndexValue(params),
                fixedRowsLength: fixedRows.length
              })
            },
            emptyNode: createEmptyNode()
          }}
        </VirtualGrid>
      }
      const renderFooter = () => {
        const footerRowsLength = footerRows.length
        if (!footerRowsLength && !slots.footer) {
          // 只有main-table才显示空组件
          return null
        }
        const HIDDEN_KEYS = ['__operation_key', '_selection', '_radio']
        const footerColumns = this.columnsVisible.map(col => {
          if (HIDDEN_KEYS.includes(col.key)) {
            return {
              ...col,
              rowCellRender: null
            }
          } else {
            return col
          }
        })
        const footerAttrs = {
          props: {
            store: $props.store,
            width: this.width,
            rowHeight: $props.rowHeight,
            rowsLength: footerRowsLength,
            type: $props.type,
            columns: footerColumns,
          },
          ref: 'footerGrid'
        }
        return <Footer {...footerAttrs}>
          {{
            default: (params) => {
              const rowData = footerRows[params.rowIndex]
              return slots.row({
                ...params,
                rowData,
                ...commonRowParams,
                _index: rowData.$index || rowData._index,
                showSelection: false,
                columns: footerColumns,
                isFooter: true,
              })
            },
            footer: slots.footer
          }}
        </Footer>
      }
      const createdHeader = () => {
        const headerAttrs = {
          props: {
            width: this.width,
            headerHeight: $props.headerHeight,
            headerColumns: this.headerColumns,
            rowColumns: this.columnsVisible,
            rowHeight: $props.rowHeight,
            store: $props.store,
            type: $props.type,
            rowsLength: fixedRows.length,
            border: $props.border,
            handleEvent: this.handleHeaderEvent,
          },
          ref: 'headerRef'
        }
        return <Header {...headerAttrs}>
          {{
            ...slots,
            row: (params) => {
              const rowData = fixedRows[params.rowIndex]
              return slots.row({
                ...params,
                rowData,
                ...commonRowParams,
                isFixedRow: true
              })
            },
          }}
        </Header>
      }
      return (
        <div class="kye-table-v2__content">
          { renderFooter() }
          { renderTableBody() }
          { createdHeader() }
        </div>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/components/core-table.js